// The four views of the business (Stage 4.6b) — the one place the screens talk to their API (server/ai/insightsRoutes.js).
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import axiosInstance from "../../../../services/axiosInstance";

// One view for the date filter's days: { view, timezone, scope, ...the view's numbers }.
export const getInsights = (view, { dateFrom = "", dateTo = "" } = {}) =>
  axiosInstance.get(`/Analytics/insights/${view}`, { params: { dateFrom: dateFrom || undefined, dateTo: dateTo || undefined } }).then(({ data }) => data);

// The weekly digest (4.6c): the latest weeks, read, made now, and how it is sent.
export const getDigests = () => axiosInstance.get("/Analytics/digests").then(({ data }) => data);
export const markDigestRead = (id) => axiosInstance.post(`/Analytics/digests/${id}/read`).then(({ data }) => data);
export const makeDigestNow = () => axiosInstance.post("/Analytics/digests/now").then(({ data }) => data);
export const getDigestSettings = () => axiosInstance.get("/Analytics/digest-settings").then(({ data }) => data);
export const saveDigestSettings = (patch) => axiosInstance.patch("/Analytics/digest-settings", patch).then(({ data }) => data);

// Who may open the business-wide views: the owner, and an agent whose analytics permission is "all". An agent otherwise sees
// their own row of the employees view only (the owner's decision, 2026-10-28). null while it is being read.
export function useInsightsAccess() {
  const user = useSelector((s) => s.auth.user);
  const isAgent = user?.accountType === "subaccount";
  const [scope, setScope] = useState(isAgent ? null : "all");
  useEffect(() => {
    if (!isAgent) { setScope("all"); return undefined; }
    let alive = true;
    axiosInstance.get("/crm/v2/my-perms")
      .then(({ data }) => { if (alive) setScope(data?.perms?.analytics === "all" ? "all" : "own"); })
      .catch(() => { if (alive) setScope("own"); });
    return () => { alive = false; };
  }, [isAgent]);
  return scope;
}

// A view's numbers for the date filter, read again when the days change.
export function useInsights(view, dateFrom, dateTo, { enabled = true } = {}) {
  const [state, setState] = useState({ data: null, loading: enabled, error: null });
  useEffect(() => {
    if (!enabled) { setState({ data: null, loading: false, error: null }); return undefined; }
    let alive = true;
    setState((s) => ({ ...s, loading: true, error: null }));
    getInsights(view, { dateFrom, dateTo })
      .then((data) => { if (alive) setState({ data, loading: false, error: null }); })
      .catch((e) => { if (alive) setState({ data: null, loading: false, error: e?.response?.status === 403 ? "not_allowed" : "failed" }); });
    return () => { alive = false; };
  }, [view, dateFrom, dateTo, enabled]);
  return state;
}
